import { Icon, Label } from "semantic-ui-react";
import { CURRENCY_SYMBOL } from "../../../constant";
import { capitalizeFirstLetter } from "../../../replace_str_constant";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Record = ({
  single,
  amounts,
  time,
  method,
  status,
  lastBalance,
  props,
}) => {
  const { t } = useTranslation();
  const i18nStatus = (key) => t(`status.${key}`);
  const i18n = (key) => t(`transaction.${key}`);

  const [openDetail, setOpenDetail] = useState(false);

  const statusFilter = (status) => {
    switch (status) {
      case "Cancel":
        return { text: i18nStatus("Cancelled"), color: "red" };
        break;
      case 0:
        return { text: i18nStatus("Confirming"), color: "orange" };
        break;
      case "In progress":
        return { text: i18nStatus("Processing"), color: "yellow" };
        break;
      case 2:
        return { text: i18nStatus("Finish"), color: "green" };
        break;
      case "Completed":
        return { text: i18nStatus("Finish"), color: "green" };
        break;
      case "Already applied":
        return { text: i18nStatus("Already applied"), color: "yellow" };
        break;
      default:
        return { text: i18nStatus("Error"), color: "red" };
    }
  };

  const typeFilter = (type) => {
    switch (type) {
      case "front_collect":
        return i18nStatus("Front Collect");
      case "front_deposit":
        return i18nStatus("Deposit");
      case "front_withdraw":
        return i18nStatus("Withdraw");
      case "use_gift":
        return i18nStatus("Gift");
      case "backend_deposit":
        return i18nStatus("Backend Deposit");
      case "backend_withdraw":
        return i18nStatus("Backend Withdraw");
      case "cash_withdraw":
        return i18nStatus("Cash Withdraw");
      case "cash_deposit":
        return i18nStatus("Cash Deposit");
      case "commission":
        return i18nStatus("Commission");
      case "api_deposit":
        return i18nStatus("Deposit");
      case "api_withdraw":
        return i18nStatus("Withdraw");
      case "backend_use_gift":
        return i18nStatus("Gift");
      case "backwater_":
        return i18nStatus("Backwater");
      case "backwater_-":
        return i18nStatus("Backwater");
      default:
        const splitType = type?.split("to");
        const filterWalletWord = (word) => {
          if (word === "v") {
            return i18n("v");
          } else if (word?.includes("back_")) {
            return word?.replace("back_", "");
          } else if (word?.includes("return_")) {
            return word?.replace("return_", "");
          } else {
            return word;
          }
        };
        return `${filterWalletWord(splitType?.[0])} ${i18n(
          "to"
        )} ${filterWalletWord(splitType?.[1])?.replace("Single", "")}`;
    }
  };

  return (
    <>
      <section
        className={`${
          single
            ? "bg-base-white dark:bg-base-dark"
            : "bg-base-light-white dark:bg-base-light-dark"
        } p-common-padding-x border dark:border-base-light-dark flex justify-between relative cursor-pointer ${
          openDetail ? "rounded-t-[5px]" : "rounded-[5px]"
        }`}
        onClick={() => setOpenDetail(!openDetail)}
      >
        <div className="flex flex-col justify-between">
          <p className="text-transaction-text dark:text-base-light-white text-lg font-semibold mb-[7px]">
            {typeFilter(props?.memo)}
          </p>
          <p className="text-dark-gray-text text-sm mb-0">{time}</p>
        </div>

        <div className="flex flex-col justify-between items-end">
          <span className="text-base-light-dark dark:text-base-light-white text-lg font-semibold mb-[7px]">
            {CURRENCY_SYMBOL}
            {amounts}
          </span>
          <p className="text-main-color text-sm mb-0">
            <Label color={statusFilter(status)?.color}>
              {statusFilter(status)?.text}
            </Label>
          </p>
        </div>
        <div className="absolute absolute-center !top-[75%] text-light-text">
          <Icon name="triangle down" />
        </div>
      </section>
      {openDetail && (
        <section
          className={`${
            single
              ? "bg-base-white dark:bg-base-dark"
              : "bg-base-light-white dark:bg-base-light-dark"
          } ${
            openDetail && "rounded-b-[5px]"
          } border dark:border-base-light-dark p-common-padding-x text-dark-gray-text dark:text-base-white`}
        >
          <p className="text-sm">
            {i18n("action")}:{" "}
            <span className="font-semibold text-base tracking-tight">
              {typeFilter(props?.memo)}
            </span>
          </p>
          <p className="text-sm">
            {i18n("transactionTime")}:{" "}
            <span className="font-semibold text-base tracking-tight">
              {time}
            </span>
          </p>
          <p className="text-sm">
            {i18n("amounts")}:{" "}
            <span className="font-semibold text-base tracking-tight">
              {amounts}
            </span>
          </p>
          <p className="text-sm">
            {i18n("lastBalance")}:{" "}
            <span className="font-semibold text-base tracking-tight">
              {lastBalance}
            </span>
          </p>
        </section>
      )}
    </>
  );
};

export default Record;
